import { InputHTMLAttributes, forwardRef } from "react";

export interface InputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "prefix"
> {
  label?: string;
  error?: string;
  suffix?: React.ReactNode;
  prefix?: React.ReactNode;
  containerClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    { className, containerClassName, label, error, suffix, prefix, ...props },
    ref,
  ) => {
    return (
      <div className={`w-full ${containerClassName || ""}`}>
        {label && (
          <label className="block text-sm font-bold text-gray-700 dark:text-slate-400 mb-2 ml-1">
            {label}
          </label>
        )}
        <div className="relative group transition-all duration-300 mb-4">
          {prefix && (
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-600 transition-colors pointer-events-none z-10">
              {prefix}
            </div>
          )}

          <input
            ref={ref}
            className={`w-full bg-gray-50 dark:bg-[#1b254b]/50 border border-gray-200 dark:border-white/10 rounded-xl py-3.5 
                            focus:bg-white dark:focus:bg-[#0b1437] focus:ring-4 focus:ring-blue-500/10 dark:focus:ring-white/5 focus:border-blue-500 dark:focus:border-white/20 
                            outline-none transition-all duration-300 placeholder:text-gray-400 dark:placeholder:text-slate-600 text-gray-800 dark:text-slate-200 font-medium
                            ${prefix ? "pl-11" : "pl-4"} 
                            ${suffix ? "pr-11" : "pr-4"} 
                            ${error ? "border-red-500 focus:border-red-500 focus:ring-red-500/10" : ""} 
                            ${className || ""}`}
            {...props}
          />

          {suffix && (
            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer z-10">
              {suffix}
            </div>
          )}
        </div>
        {error && (
          <p className="mt-1.5 text-xs font-semibold text-red-500 flex items-center gap-1.5 ml-1">
            {error}
          </p>
        )}
      </div>
    );
  },
);

Input.displayName = "Input";
